import React, { useState, useEffect, useContext, useRef } from "react";
import { Row, Col, Form, Card, Button, Table } from "react-bootstrap";
import PermissionContext from "../../Store/permission-context";
import classes from "./Sales.module.css";
import InputRadio from "../Elements/InputRadio.jsx";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import TableReceipt from "./TableReceipt.jsx";
// import TableReceiptMini from "./TableReceiptMini.jsx";
import { AutoComplete, Divider } from "rsuite";
import ProcessingModal from "./Modals/ProcessingModal.jsx";
import "rsuite/dist/rsuite.css";
import { set } from "rsuite/esm/internals/utils/date/index.js";
const Sales = () => {
  const PCtx = useContext(PermissionContext);
  const [valval, setvalval] = useState("");
  const [ItemID, setItemID] = useState("");
  const [Itemname, setItemname] = useState("");
  const [SoldIn, setSoldIn] = useState("");
  const [InpVal, setInpVal] = useState("");
  const [SP1, setSP1] = useState("");
  const [SP2, setSP2] = useState("");
  const [SP3, setSP3] = useState("");
  const [UP1, setUP1] = useState("");
  const [UP2, setUP2] = useState("");
  const [UP3, setUP3] = useState("");
  const [Nop, setNop] = useState("");
  const [Nou, setNou] = useState("");
  const [display, setdisplay] = useState(false);
  const [isFocus, setisFocus] = useState(false);
  const [GoAhead, setGoAhead] = useState(false);
  const [DisableAll, setDisableAll] = useState(false);
  const [showReceipt, setshowReceipt] = useState(false);
  const [ShowProcessing, setShowProcessing] = useState(false);
  const [QBulk, setQBulk] = useState("");
  const [QUnit, setQUnit] = useState("");
  const [Converter, setConverter] = useState("");
  const [QBulkError, setQBulkError] = useState(false);
  const [QUnitError, setQUnitError] = useState(false);
  const [ErrorMsg, setErrorMsg] = useState(false);
  const [CheckBlur, setCheckBlur] = useState(false);
  const [AllGoodNames, setAllGoodNames] = useState([]);
  const [AllGoodIds, setAllGoodIds] = useState([]);
  const [AllOrderedItems, setAllOrderedItems] = useState([]);
  const [BulkPriceSelected, setBulkPriceSelected] = useState("");
  const [PackPriceSelected, setPackPriceSelected] = useState("");
  const [UnitPriceSelected, setUnitPriceSelected] = useState("");
  const [TotalPayable, setTotalPayable] = useState(0);
  const [SurCharge, setSurCharge] = useState(0);
  const [TotalPayableWithDiscount, setTotalPayableWithDiscount] = useState(0);
  const [showDiscount, setshowDiscount] = useState(false);
  const [Discount, setDiscount] = useState("0");
  const [Cash, setCash] = useState("");
  const [POS, setPOS] = useState("");
  const [Transfer, setTransfer] = useState("");
  const [Tender, setTender] = useState("0");
  const [ChangeCollected, setChangeCollected] = useState("0");
  const [PaymentMode, setPaymentMode] = useState("");
  const [PaymentModePerfect, setPaymentModePerfect] = useState(false);
  const [CustomerName, setCustomerName] = useState("Customer");
  const [PhoneNumber, setPhoneNumber] = useState("080XXXXXXXX");
  const [OpenCustomerForm, setOpenCustomerForm] = useState(true);
  const [OrderInProgress, setOrderInProgress] = useState(true);
  const [CheckOver, setCheckOver] = useState(true);
  const [CustomerChecked, setCustomerChecked] = useState(false);
  const [Printing, setPrinting] = useState(true);
  const [ReceiptDetails, setReceiptDetails] = useState({});
  const [GoodsNotAvailable, setGoodsNotAvailable] = useState([]);
  const [RegisteredPhone, setRegisteredPhone] = useState([]);
  const [RegisteredNames, setRegisteredNames] = useState([]);
  const [RegisteredID, setRegisteredID] = useState([]);
  const [PickedRegisteredName, setPickedRegisteredName] = useState("");
  const [PickedCustomerID, setPickedCustomerID] = useState("");
  const [PickedCustomerPhone, setPickedCustomerPhone] = useState("");
  const ItemIDRef = useRef(null);
  // const BRef = useRef(null);
  // const QRef = useRef(null);
  // To load stored items from the database
  useEffect(() => {
    let Allnames = [];
    let AllIDs = [];
    const getData = async () => {
      let AllGoods = await PCtx.connectAxios("getallgoods.php", "");
      for (var y = 0; y < AllGoods.length; y++) {
        AllIDs[y] = AllGoods[y][0];
        Allnames[y] = AllGoods[y][1];
      }
    };
    getData();
    setAllGoodNames(Allnames);

    setAllGoodIds(AllIDs);
  }, []);

  useEffect(() => {
    if (showReceipt) {
      window.print();
    }
  }, [showReceipt]);

  useEffect(() => {
    setGoAhead(true);
  }, [QUnit]);

  useEffect(() => {
    let Cs = Cash === "" ? 0 : parseFloat(Cash);
    let Ps = POS === "" ? 0 : parseFloat(POS);
    let Ts = Transfer === "" ? 0 : parseFloat(Transfer);
    let AllMode = Cs + Ps + Ts;
    if (
      AllMode != 0 &&
      parseFloat(AllMode) === parseFloat(TotalPayableWithDiscount)
    ) {
      setPaymentModePerfect(true);
    } else {
      setPaymentModePerfect(false);
    }
  }, [Cash, POS, Transfer, TotalPayableWithDiscount]);

  useEffect(() => {
    if (ItemIDRef.current && !OpenCustomerForm) {
      ItemIDRef.current.focus();
    }
  }, [OpenCustomerForm]);

  useEffect(() => {
    if (parseFloat(Tender) >= parseFloat(TotalPayableWithDiscount)) {
      setChangeCollected(
        parseFloat(Tender) - parseFloat(TotalPayableWithDiscount),
      );
    } else {
      setChangeCollected(0);
    }
  }, [Tender]);

  useEffect(() => {
    setTender("");
    setChangeCollected("");
  }, [TotalPayableWithDiscount]);

  useEffect(() => {
    const Proceed = async () => {
      setShowProcessing(true);
      if (GoodsNotAvailable.length === 0) {
        let rcd = Date.now() + Math.floor(Math.random() * 100 + 0);
        rcd = rcd.toString();
        rcd = rcd.substring(2);
        rcd = "R" + rcd;
        let receiptdate =
          new Date().toDateString() + ", " + new Date().toLocaleTimeString();

        setTotalPayableWithDiscount(TotalPayableWithDiscount + SurCharge);
        let SalesData = {
          OrderData: AllOrderedItems,
          Discount: Discount,
          Payable: TotalPayable,
          PayableWithDiscount: TotalPayableWithDiscount,
          Cash: Cash === "" ? 0 : Cash,
          POS: POS === "" ? 0 : POS,
          Transfer: Transfer === "" ? 0 : Transfer,
          Tender: Tender === "" ? 0 : Tender,
          PaymentMode: PaymentMode,
          ChangeCollected: ChangeCollected === "" ? 0 : ChangeCollected,
          cn: CustomerChecked ? PickedRegisteredName : CustomerName,
          pn: PhoneNumber,
          ShowReceipt: true,
          rcn: rcd,
          rdt: receiptdate,
          Staff: PCtx.Username,
          cstid: PickedCustomerID,
          IsRegisteredCustomer: CustomerChecked,
        };

        let OrdersSaved = await PCtx.connectAxios(
          "savesalesdetails.php",
          SalesData,
        );
        // console.log(OrdersSaved);
        setShowProcessing(false);
        if (OrdersSaved.includes("success")) {
          setReceiptDetails(SalesData);
          setOrderInProgress(false);
          setshowReceipt(true);
        }
      } else {
        let unavailable = "";
        for (var b = 0; b < GoodsNotAvailable.length; b++) {
          let newunv =
            b === GoodsNotAvailable.length - 1
              ? GoodsNotAvailable[b]
              : GoodsNotAvailable[b] + ",\n ";
          unavailable = unavailable + newunv;
        }
        setPrinting(true);
        PCtx.displayAlert(
          "INSUFFICIENT QUANTITY",
          "The following goods have just been sold out and are no longer available in the stock.\n" +
            unavailable,
          "danger",
        );
      }
    };

    if (AllOrderedItems.length > 0) {
      Proceed();
    }
  }, [CheckOver]);

  // const filterOptions = (options, { inputValue }) => {
  //   return options.filter((option) =>
  //     option.toLowerCase().includes(inputValue.toLowerCase())
  //   );
  // };

  const setInputChange = (e, val) => {
    val = val.charAt(0).toUpperCase() + val.slice(1);
    setInpVal(val);
    setItemname(val);
  };

  // const filterOptions = (options, { inputValue }) => {
  //   const matchSequentialLetters = (option, input) => {
  //     const optionLower = option.toLowerCase();
  //     const inputLower = input.toLowerCase();
  //     let optionIndex = 0;

  //     for (let inputIndex = 0; inputIndex < inputLower.length; inputIndex++) {
  //       optionIndex = optionLower.indexOf(inputLower[inputIndex], optionIndex);
  //       if (optionIndex === -1) {
  //         return false;
  //       }
  //       optionIndex++; // Move to the next character in the option
  //     }
  //     return true;
  //   };

  //   return options.filter((option) =>
  //     matchSequentialLetters(option, inputValue)
  //   );
  // };

  const getItemnameChangeAction = (e, valEntered) => {
    setisFocus(false);
    if (valEntered != null && valEntered != "") {
      valEntered = valEntered.toString();

      setItemname(valEntered);
      if (
        !isNaN(valEntered.replace(/[^a-zA-z0-9]/g)) &&
        AllGoodIds.includes(valEntered)
      ) {
        let index = AllGoodIds.indexOf(valEntered);
        let item = AllGoodNames[index];

        setItemname(item);
        getItemnameSelection(item);
      }
    }
  };

  const getItemnameSelection = async (it) => {
    let goodproperties = await PCtx.connectAxios("getitemdetails.php", it);
    setSoldIn(goodproperties.Soldin);
    setItemID(goodproperties.GoodID);
    setQBulk(goodproperties.QBulk);
    setQUnit(goodproperties.QUnit);
    setConverter(goodproperties.Converter);
    setSP1(goodproperties.SP1);
    setSP2(goodproperties.SP2);
    setSP3(goodproperties.SP3);
    setUP1(goodproperties.UP1);
    setUP2(goodproperties.UP2);
    setUP3(goodproperties.UP3);
    setPackPriceSelected(goodproperties.SP1);
    setUnitPriceSelected(goodproperties.UP1);
    setdisplay(true);
    setNop("0");
    setNou("0");
    // BRef.current.focus();
  };

  const secondGetItemnameSelection = async (it) => {
    let Nop = it.nop;
    let Nou = it.nou;
    let itnm = it.ordername;

    let goodproperties = await PCtx.connectAxios("getitemdetails.php", itnm);

    let Converter = goodproperties.Converter;
    let QB = goodproperties.QBulk;
    let QU = goodproperties.QUnit;

    let NP = Nop === "" || Nop === null ? 0 : parseFloat(Nop);
    let NU = Nou === "" || Nou === null ? 0 : parseFloat(Nou);
    QB = QB === "" || QB === null ? 0 : parseFloat(QB);
    QU = QU === "" || QU === null ? 0 : parseFloat(QU);
    let thisorder = parseFloat(Converter) * parseFloat(NP) + parseFloat(NU);
    let availableorder = parseFloat(Converter) * QB + QU;

    if (availableorder < thisorder) {
      await setGoodsNotAvailable((prevGoodsNotAvailable) => [
        ...prevGoodsNotAvailable,
        itnm,
      ]);
    }
  };

  const ReConfirmOrderAvailability = async (TheOrders) => {
    setPrinting(false);
    setGoodsNotAvailable([]);
    for (var r = 0; r < TheOrders.length; r++) {
      let theReturn = await secondGetItemnameSelection(TheOrders[r]);
      if (r == TheOrders.length - 1) {
        setCheckOver(!CheckOver);
      }
    }
  };

  useEffect(() => {
    if (!isFocus) {
      getTypedText();
    }
  }, [Itemname]);

  const getTypedText = () => {
    setisFocus(false);
    if (Itemname === "") {
      setdisplay(false);
      setErrorMsg(false);

      setUP1("");
      setUP2("");
      setUP3("");
    } else {
      let ITN = Itemname.charAt(0).toUpperCase() + Itemname.slice(1);
      if (AllGoodNames.includes(ITN)) {
        setGoAhead(true);
        getItemnameSelection(ITN);
      } else {
        setQUnit("");
        setUP1("");
        setUP2("");
        setUP3("");
        setdisplay(false);
        setErrorMsg(true);
        setGoAhead(false);
      }
    }
  };

  const setTheValue = (e) => {
    let nm = e.target.name;
    let vl = e.target.value;

    if (nm === "nop" && !isNaN(vl)) {
      setNop(vl);
      setQBulkError(true);
    } else {
      if (nm === "nou" && !isNaN(vl)) {
        setNou(vl);
        setQUnitError(true);
      } else {
        if (nm === "custname") {
          setCustomerName(vl);
        } else {
          if (nm === "custphone") {
            setPhoneNumber(vl);
          } else {
            if (nm === "Cash" && !isNaN(vl)) {
              setCash(vl);
            } else {
              if (nm === "POS" && !isNaN(vl)) {
                setPOS(vl);
              } else {
                if (nm === "Transfer" && !isNaN(vl)) {
                  setTransfer(vl);
                } else {
                  if (nm === "Tender" && !isNaN(vl)) {
                    setTender(vl);
                  } else {
                    if (nm === "ChangeCollected" && !isNaN(vl)) {
                      setChangeCollected(vl);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };

  const radioPriceChanged = (e) => {
    if (e.target.checked) {
      if (e.target.name === "PriceBulk") {
        setPackPriceSelected(e.target.value);
      } else {
        if (e.target.name === "PriceUnit") {
          setUnitPriceSelected(e.target.value);
        }
      }
    }
  };

  const SetTheCreditMode = (e) => {
    if (e.target.checked) {
      setCash(0);
      setTender(0);
      setPOS(0);
      setTransfer(0);
      setPaymentMode("Credit");
      setDisableAll(true);
    } else {
      setPaymentMode("");
      setDisableAll(false);
    }
  };

  const RemovingItems = async (dsIt, amt) => {
    await removeItem(dsIt, amt);
    if (PaymentMode === "Transfer" || PaymentMode === "POS") {
      await removeItem(PaymentMode + " Charges", SurCharge);
    }
  };

  const removeItem = async (dsItem, amount) => {
    await setAllOrderedItems((prevAllOrderedItems) =>
      prevAllOrderedItems.filter((itm) => itm.ordername !== dsItem),
    );
    await setTotalPayableWithDiscount(
      (prevTotalPayable) => prevTotalPayable - amount,
    );
    await setTotalPayable((prevTotalPayable) => prevTotalPayable - amount);
    if (showDiscount && Discount > 0) {
      setshowDiscount(false);
      setDiscount(0);
      PCtx.displayAlert(
        "DISCOUNT RESET",
        "Please note that the discount is no longer applied. You can reapply it after all your orders have been concluded",
        "warning",
      );
    }
    setSurCharge(0);
    setPaymentMode("");
  };

  const getOrderDetails = async (e) => {
    e.preventDefault();
    if (GoAhead) {
      let Ck = false;
      for (var m = 0; m < AllOrderedItems.length; m++) {
        let AOI = { ...AllOrderedItems[m] };
        if (AOI.ordername === Itemname) {
          Ck = true;
          setNou("");
          break;
        }
      }
      if (!Ck) {
        let TotalPrice = 0;
        let NP = Nop === "" || Nop === null ? 0 : parseFloat(Nop);
        let NU = Nou === "" || Nou === null ? 0 : parseFloat(Nou);
        let QB = QBulk === "" || QBulk === null ? 0 : parseFloat(QBulk);
        let QU = QUnit === "" || QUnit === null ? 0 : parseFloat(QUnit);
        let psp =
          PackPriceSelected === "" || PackPriceSelected === null
            ? 0
            : parseFloat(PackPriceSelected);
        let usp =
          UnitPriceSelected === "" || UnitPriceSelected === null
            ? 0
            : parseFloat(UnitPriceSelected);

        let thisorder = parseFloat(Converter) * parseFloat(NP) + parseFloat(NU);
        let availableorder = parseFloat(Converter) * QB + QU;

        if (availableorder >= thisorder) {
          TotalPrice = NP * psp + NU * usp;
          let desc;
          if (NP === 0 && NU > 0) {
            desc = NU + " Unit(s)";
          } else {
            if (NU === 0 && NP > 0) {
              desc = NP + " " + SoldIn + "(s)";
            } else {
              if (NP > 0 && NU > 0) {
                desc = NP + " " + SoldIn + "(s) and " + NU + " Units";
              }
            }
          }

          if (TotalPrice > 0 && !isNaN(TotalPrice)) {
            if (PaymentMode === "Transfer" || PaymentMode === "POS") {
              await removeItem(PaymentMode + " Charges", SurCharge);
            }
            let ordereddetails = {
              description: desc + " of " + Itemname,
              itemid: ItemID,
              ordername: Itemname,
              bulkprice: NP > 0 ? PackPriceSelected : "-",
              unitprice: NU > 0 ? UnitPriceSelected : "-",
              subtotal: TotalPrice,
              nop: NP,
              nou: NU,
              converter: Converter,
              rdesc: desc + " of ",
            };

            // console.log(ordereddetails);
            setAllOrderedItems((prevAllOrderedItems) => [
              ...prevAllOrderedItems,
              ordereddetails,
            ]);

            setTotalPayable(
              (prevTotalPayable) => prevTotalPayable + TotalPrice,
            );
            setTotalPayableWithDiscount(
              (prevTotalPayable) => prevTotalPayable + TotalPrice,
            );
            setSoldIn("");
            setQBulk("");
            setQUnit("");
            setConverter("");
            setSP1("");
            setSP2("");
            setSP3("");
            setUP1("");
            setUP2("");
            setUP3("");
            setItemname("");
            setNop("");
            setNou("");
            setInpVal("");

            ItemIDRef.current.focus();
            if (showDiscount && Discount > 0) {
              setshowDiscount(false);
              setDiscount(0);
              PCtx.displayAlert(
                "DISCOUNT RESET",
                "Please note that the discount is no longer applied. You can reapply it after all your orders have been concluded",
                "warning",
              );
            }
          } else {
            PCtx.displayAlert(
              "PRICE ERROR",
              "Please Check the Price and Quantity you picked",
              "danger",
            );
          }
        } else {
          PCtx.displayAlert(
            "INSUFFICIENT QUANTITY",
            "The available quantity of " +
              Itemname +
              " in stock is not enough for the ordered quantity. Please add to the stock or order for lesser quantity",
            "danger",
          );
        }
      } else {
        PCtx.displayAlert(
          "ITEM PICKED ALREADY",
          Itemname +
            " has been picked already in your ordered list. If you wish to change the quantity of " +
            Itemname +
            ", delete from the placed ordered list and order again",
          "warning",
        );
      }
    } else {
      PCtx.displayAlert(
        "NOT EXISTING",
        Itemname +
          " is not existing in the Inventory. please check the Item name entered and try again",
        "danger",
      );
    }
  };

  const getCustomerDetails = (e) => {
    e.preventDefault();
    if (CustomerChecked) {
      if (RegisteredNames.includes(PickedRegisteredName)) {
        setCustomerName(PickedRegisteredName);
        setPhoneNumber(PickedCustomerPhone);
        setOpenCustomerForm(false);
      } else {
        PCtx.displayAlert(
          "ERROR",
          PickedRegisteredName +
            " is not a registered name. Kindly register it first before you continue",
          "warning",
        );
      }
    } else {
      setCustomerName(CustomerName.toUpperCase());
      setOpenCustomerForm(false);
    }
  };

  const PaymentModeHandler = (e) => {
    setPaymentMode(e.target.value);
    let Pm = e.target.value;
  };

  const ApplyDiscount = (e) => {
    let dsc = e.target.value;
    if (showDiscount && TotalPayable > 0 && !isNaN(dsc)) {
      let discount = parseFloat(dsc) > 0 ? parseFloat(dsc) : 0;
      setDiscount(discount);
      setTotalPayableWithDiscount(parseFloat(TotalPayable) - discount);
    }
  };

  const ShowDiscountHandler = () => {
    setshowDiscount(!showDiscount);
    if (showDiscount) {
      setDiscount(0);
      setTotalPayableWithDiscount(TotalPayable);
    }
  };

  const StartNewSales = () => {
    window.location.reload();
  };

  const getCustomerSelected = (cst) => {
    setPickedRegisteredName(cst);

    let ind = RegisteredNames.findIndex((customer) => customer === cst);
    setPickedCustomerPhone(RegisteredPhone[ind]);
    setPickedCustomerID(RegisteredID[ind]);
    setPickedRegisteredName(RegisteredNames[ind]);
  };

  const checkBoxHandler = async (e) => {
    let checker = e.target.checked;
    setCustomerChecked(checker);
    if (checker) {
      let RC = await PCtx.connectAxios("getallcustomers.php", "");

      if (!RC.includes("Error")) {
        let RegNames = [];
        let RegID = [];
        let RegPhone = [];
        for (var t = 0; t < RC.length; t++) {
          RegNames = [...RegNames, RC[t].BusinessName];
          RegID = [...RegID, RC[t].CustomerID];
          RegPhone = [...RegPhone, RC[t].PhoneNumber];
        }
        setRegisteredNames(RegNames);
        setRegisteredID(RegID);
        setRegisteredPhone(RegPhone);
      }
    } else {
      setPickedRegisteredName("");
    }
  };
  return (
    <Row className={classes.margin4printing}>
      <Col md={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0">SALES</Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {OpenCustomerForm && (
          <Row className="mt-5 justify-content-around">
            <Col md={4} sm={12} xs={12}>
              <Form onSubmit={getCustomerDetails}>
                <Card>
                  <Card.Header>Customer's Details</Card.Header>
                  <Card.Body>
                    <Form.Group className="mb-0" controlId={valval}>
                      <Form.Label
                        style={{
                          color: "brown",
                          paddingBottom: "0px",
                          marginBottom: "0px",
                        }}
                      >
                        Customer's Name
                      </Form.Label>
                      <br />
                      <input type="checkbox" onChange={checkBoxHandler} />
                      Registered Customer
                      {!CustomerChecked ? (
                        <Form.Control
                          type="text"
                          value={CustomerName}
                          name="custname"
                          onChange={setTheValue}
                        />
                      ) : (
                        <AutoComplete
                          data={RegisteredNames}
                          value={PickedRegisteredName.toUpperCase()}
                          onChange={setPickedRegisteredName}
                          onSelect={getCustomerSelected}
                          style={{
                            border: "1px solid brown",
                            backgroundColor: "#b3ff66",
                            borderRadius: "3px",
                          }}
                        />
                      )}
                    </Form.Group>
                    <Form.Group className="mt-3" controlId={valval}>
                      <Form.Label style={{ color: "brown" }}>
                        Customer's Phone Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={
                          !CustomerChecked ? PhoneNumber : PickedCustomerPhone
                        }
                        name="custphone"
                        onChange={setTheValue}
                      />
                    </Form.Group>
                  </Card.Body>
                  <Card.Footer>
                    <Row className="justify-content-end">
                      <Col md={4} sm={4} xs={4}>
                        <Button variant="info" type="submit">
                          Start Order
                        </Button>
                      </Col>
                    </Row>
                  </Card.Footer>
                </Card>
              </Form>
            </Col>
          </Row>
        )}
        {!OpenCustomerForm && (
          <Row className="justify-content-around">
            {OrderInProgress && (
              <Col
                md={{ span: 4, order: 1 }}
                sm={{ span: 12, order: 2 }}
                xs={{ span: 12, order: 2 }}
                className={classes.hide4printing}
              >
                <Row className={classes.hide4printing}>
                  <Col md={12} sm={12}>
                    <Card>
                      <Card.Header>
                        PLACED ORDERS FOR {CustomerName.toUpperCase()}
                      </Card.Header>
                      <Card.Body>
                        <Row>
                          <Col
                            md={12}
                            sm={12}
                            style={{
                              height: "350px",
                              overflowY: "scroll",
                              marginButtom: "20px",
                            }}
                          >
                            <Table
                              striped
                              bordered
                              hover
                              style={{ fontFamily: "Times New Roman" }}
                            >
                              <thead>
                                <tr>
                                  <th className="text-center">SN</th>
                                  <th className="text-center">Description</th>
                                  <th className="text-center">Bulk Price</th>
                                  <th className="text-center">Unit Price</th>
                                  <th className="text-center">Sub Total</th>
                                  <th className="text-center">Delete</th>
                                </tr>
                              </thead>
                              <tbody>
                                {AllOrderedItems.map((order, index) => (
                                  <tr key={index}>
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-center">
                                      {order.description}
                                    </td>

                                    <td className="text-center">
                                      {order.bulkprice}
                                    </td>
                                    <td className="text-center">
                                      {order.unitprice}
                                    </td>
                                    <td className="text-center">
                                      {order.subtotal}
                                    </td>
                                    <td className="text-center">
                                      <Button
                                        variant="danger"
                                        type="button"
                                        className="btn-sm"
                                        disabled={
                                          order.itemid === "12345"
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          RemovingItems(
                                            order.ordername,
                                            order.subtotal,
                                          )
                                        }
                                      >
                                        -
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={12} sm={12}>
                    <Card>
                      <Card.Body className="py-1">
                        <Row
                          className="justify-content-center"
                          style={{ backgroundColor: "" }}
                        >
                          <Col md={4} lg={4} xs={4} sm={4}>
                            <Form.Group className="mb-0" controlId="name">
                              <Form.Label
                                style={{ color: "brown" }}
                                className="my-0"
                              >
                                Cash
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={Cash}
                                name="Cash"
                                onChange={setTheValue}
                                className="my-0"
                                readOnly={DisableAll}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4} xs={4} sm={4}>
                            <Form.Group className="mb-0" controlId="name">
                              <Form.Label
                                style={{ color: "brown" }}
                                className="my-0"
                              >
                                POS
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={POS}
                                name="POS"
                                className="my-0"
                                onChange={setTheValue}
                                readOnly={DisableAll}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4} xs={12} sm={12}>
                            <Form.Group className="mb-0" controlId="name">
                              <Form.Label
                                style={{ color: "brown" }}
                                className="my-0"
                              >
                                Transfer
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={Transfer}
                                name="Transfer"
                                onChange={setTheValue}
                                className="my-0"
                                readOnly={DisableAll}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12} lg={12} sm={12} xs={12}>
                            <label>
                              <input
                                type="checkbox"
                                onChange={SetTheCreditMode}
                              />
                              Sold on Credit
                            </label>
                          </Col>
                        </Row>
                        <hr className="p-1 m-1" />
                        <Row
                          className="justify-content-center py-1 border border-dark-subtle"
                          style={{ backgroundColor: "#d2d2d2" }}
                        >
                          <Col
                            md={4}
                            lg={4}
                            xs={12}
                            sm={12}
                            style={{ borderRight: "1px solid brown" }}
                          >
                            <label>
                              <input
                                type="checkbox"
                                onChange={ShowDiscountHandler}
                                checked={showDiscount}
                              />
                              Discount
                            </label>
                            {showDiscount && (
                              <input
                                type="text"
                                placeholder="Enter Amount"
                                readOnly={TotalPayable <= 0}
                                value={Discount}
                                onChange={ApplyDiscount}
                                style={{
                                  width: "100px",
                                  marginLeft: "3px",
                                  borderRadius: "2px",
                                  paddingLeft: "5px",
                                }}
                              />
                            )}
                          </Col>
                          {/*  <Col md={4} lg={4} xs={12} sm={12}>
                            <Form.Group className="mb-0" controlId="name">
                              <Form.Label
                                style={{ color: "brown" }}
                                className="my-0"
                              >
                                Tender
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={Tender}
                                name="Tender"
                                onChange={setTheValue}
                                className="my-0"
                                readOnly={DisableAll}
                              />
                            </Form.Group>
                          </Col>
                           <Col md={4} lg={4} xs={12} sm={12}>
                            <Form.Group className="mb-0" controlId="name">
                              <Form.Label
                                style={{ color: "brown" }}
                                className="my-0"
                              >
                                Change
                              </Form.Label>
                              <Form.Control
                                type="text"
                                value={ChangeCollected}
                                name="ChangeCollected"
                                onChange={setTheValue}
                                className="my-0"
                                readOnly={DisableAll}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <label>Payment Mode</label>
                            <select
                              value={PaymentMode}
                              onChange={PaymentModeHandler}
                            >
                              <option value="">Select</option>
                              <option value="Cash">Cash</option>
                              <option value="POS">POS</option>
                              <option value="Transfer">Transfer</option>
                              <option value="Credit">Credit</option>
                            </select>
                          </Col> */}
                        </Row>
                      </Card.Body>
                    </Card>
                    <Card style={{ height: "35px" }}>
                      <Card.Body>
                        <Divider className="m-0">
                          <h4 className="text-success ">
                            Total Payable = ₦{TotalPayableWithDiscount}
                          </h4>
                        </Divider>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={12}>
                    <Button
                      variant="success"
                      className="w-100 mt-1"
                      disabled={
                        (AllOrderedItems.length > 0 &&
                          PaymentModePerfect &&
                          Printing) ||
                        DisableAll
                          ? false
                          : true
                      }
                      onClick={() =>
                        ReConfirmOrderAvailability(AllOrderedItems)
                      }
                    >
                      Generate Receipt
                    </Button>
                  </Col>
                </Row>
              </Col>
            )}
            {OrderInProgress && (
              <Col
                md={{ span: 4, order: 2 }}
                sm={{ span: 12, order: 1 }}
                xs={{ span: 12, order: 1 }}
                className={classes.hide4printing}
              >
                <Card>
                  <Card.Header>NEW ITEM SALE</Card.Header>
                  <Card.Body>
                    <Form onSubmit={getOrderDetails}>
                      <Row className="justify-content-around">
                        <Col md={12}>
                          <Form.Group>
                            <Form.Label style={{ color: "brown" }}>
                              Item Name
                            </Form.Label>
                            {/* <AutoComplete
                              data={AllGoodNames}
                              value={
                                Itemname.charAt(0).toUpperCase() +
                                Itemname.slice(1)
                              }
                              onChange={(e) => getItemnameChangeAction(e)}
                              onSelect={getItemnameSelection}
                              onBlur={getTypedText}
                              style={{ border: "1px solid brown" }}
                            /> */}
                            <Autocomplete
                              disablePortal
                              id="simple-autocomplete"
                              options={AllGoodNames}
                              getOptionLabel={(option) => option}
                              renderOption={(props, option) => (
                                <li {...props}>{option}</li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Search for an Item"
                                  inputRef={ItemIDRef}
                                  onBlur={getTypedText}
                                  onFocus={() => setisFocus(true)}
                                />
                              )}
                              onInputChange={setInputChange}
                              inputValue={InpVal}
                              // filterOptions={filterOptions}
                              onChange={getItemnameChangeAction} // Set the handler here
                              value={Itemname} // Control the selected value
                            />

                            {display ? (
                              <p className="mx-0">
                                {!(SoldIn === "Piece" || SoldIn === "Unit") &&
                                  SoldIn + "s left: " + QBulk + " | "}
                                Units left: {QUnit}
                              </p>
                            ) : ErrorMsg &&
                              !AllGoodNames.includes(
                                Itemname.charAt(0).toUpperCase() +
                                  Itemname.slice(1),
                              ) ? (
                              <p className="mx-0 text-danger">
                                {Itemname} does not exist in stock. Please Check
                                the spelling and try again
                              </p>
                            ) : null}
                          </Form.Group>
                          <hr />
                        </Col>

                        <Col md={12}>
                          <Form.Group className="mb-0" controlId="name">
                            <Form.Label style={{ color: "brown" }}>
                              How many {SoldIn}(s)
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={Nop}
                              name="nop"
                              readOnly={!display || (!SP1 && !SP2 && !SP3)}
                              onChange={setTheValue}
                              style={{
                                backgroundColor: "White",
                                border: "1px solid brown",
                                fontSize: "50px",
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                              // ref={BRef}
                            />
                          </Form.Group>
                          <InputRadio
                            price={SP1}
                            disab={false}
                            Name="PriceBulk"
                            lab="1"
                            checkd={true}
                            myChange={radioPriceChanged}
                          />
                          <InputRadio
                            price={SP2}
                            disab={false}
                            Name="PriceBulk"
                            lab="2"
                            myChange={radioPriceChanged}
                          />
                          <InputRadio
                            price={SP3}
                            disab={false}
                            Name="PriceBulk"
                            lab="3"
                            myChange={radioPriceChanged}
                          />
                          <hr />
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-0" controlId="name">
                            <Form.Label style={{ color: "brown" }}>
                              How many Units?
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={Nou}
                              name="nou"
                              readOnly={!display || (!UP1 && !UP2 && !UP3)}
                              onChange={setTheValue}
                              style={{
                                backgroundColor: "White",
                                border: "1px solid brown",
                                fontSize: "50px",
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                              // ref={QRef}
                            />
                          </Form.Group>
                          <InputRadio
                            price={UP1}
                            disab={false}
                            Name="PriceUnit"
                            lab="1"
                            checkd={true}
                            myChange={radioPriceChanged}
                          />
                          <InputRadio
                            price={UP2}
                            disab={false}
                            Name="PriceUnit"
                            lab="2"
                            myChange={radioPriceChanged}
                          />
                          <InputRadio
                            price={UP3}
                            disab={false}
                            Name="PriceUnit"
                            lab="3"
                            myChange={radioPriceChanged}
                          />
                          <hr />
                        </Col>
                        <Col md={6} sm={6} xs={6} className="offset-4">
                          <Button
                            className="align-self-center"
                            variant="info"
                            type="submit"
                            disabled={Nou === "" && GoAhead}
                          >
                            Place Order
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            )}
            <Col
              md={{ span: 4, order: 3 }}
              sm={{ span: 12, order: 3 }}
              xs={{ span: 12, order: 3 }}
            >
              {/* <Card>
                <Card.Header className={classes.hide4printing}>
                  RECEIPT
                </Card.Header>
                <Card.Body className={classes.margin4printing}> */}
              <h3 className={classes.hide4printing}>RECEIPT</h3>
              {showReceipt && (
                <TableReceipt Rct={ReceiptDetails} PrintDirectly={true} />
              )}
              {/* </Card.Body>
              </Card> */}
              {!OrderInProgress && (
                <Button
                  variant="info"
                  className={`${classes.hide4printing} ${"w-100"}`}
                  onClick={StartNewSales}
                >
                  START NEW SALES
                </Button>
              )}
            </Col>
          </Row>
        )}
      </Col>
      {ShowProcessing && <ProcessingModal Show={ShowProcessing} />}
    </Row>
  );
};

export default Sales;
